import { render, staticRenderFns } from "./PRJ101P02.vue?vue&type=template&id=70d4236b&"
import script from "./PRJ101P02.vue?vue&type=script&lang=js&"
export * from "./PRJ101P02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports